<template>
    <span v-if="pricesFetched">
        <del v-if="showBargainPrice">{{ updatedPrice | formatCurrency(prices.currency, prices.locale) }}</del>
        <span v-else>{{ updatedPrice | formatCurrency(prices.currency, prices.locale, { style: 'decimal' }) }}</span>
    </span>
</template>

<script>
    import { fetchTripPrices } from '@lib/tripPrices/api';

    export default {
        props: {
            trip: {
                type: Number,
                default: 0,
                required: true
            },
            oldPrice: {
                type: Number,
                default: 0,
                required: true
            },
            showBargainPrice: {
                type: Boolean,
                default: false
            },
            apiEndpoint: {
                type: String,
                default: '/de/api/tripPrices'
            }
        },
        data () {
            return {
                prices: {
                    minPrice: 0,
                    bargainPrice: 0,
                    locale: '',
                    currency: ''
                },
                pricesFetched: false
            }
        },
        computed: {
            updatedPrice () {
                let newPrice = this.oldPrice;

                if (this.showBargainPrice && this.prices.bargainPrice > 0) {
                    newPrice = this.prices.bargainPrice;
                } else if (this.prices.minPrice > 0) {
                    newPrice = this.prices.minPrice;
                }

                return newPrice;
            }
        },
        async created () {
            await fetchTripPrices(this.apiEndpoint, this.trip).then((prices) => {
                this.prices = prices
            }).finally(() => {
                this.pricesFetched = true;
            });
        }
    }
</script>
